import React from 'react';

export function ListElement(props) {

    const { onSelect } = props;

    const handleButtonClick = () => {
        if (onSelect) {
            onSelect(props);
        }
    };

    return (
        <div className="mb-3 inv-details-box">
            <div className=" title-row-container">
                <span className="inv-details-title">
                    <div className="d-flex justify-content-between align-items-start align-items-sm-center ">
                        <div className="d-flex flex-column pe-3 ">
                            <div className="w-100">
                                <span className="title m-0 ">
                                    {props.partyName}
                                </span>
                            </div>
                            <span className="fs-18 ff-tgn-bld fc-txt-light ">
                                {
                                    (props.details == null || props.details == undefined) ? "" : props.details.map((details, index) => {
                                        if (index === props.details.length - 1) {
                                            return details;
                                        } else {
                                            return details + ", ";
                                        }
                                    })}
                            </span>
                        </div>
                        <div className="d-none d-md-block">
                            <button className=" btn magenta  px-2 " target="_blank" onClick={handleButtonClick}>
                                Kiválasztás
                            </button>
                        </div>
                    </div>
                </span>
                <span className="fs-16 ff-tgn fc-txt-light ">
                    {props.owner}
                </span>
            </div>
        </div>
    );
}
